import { createAction, props } from '@ngrx/store';

export const loadDepartments = createAction('[Employee] Load Departments');
export const loadDepartmentsSuccess = createAction('[Employee] LoadDepartments Success', props<{ payload: any }>());
export const loadDepartmentsFail = createAction('[Employee] Load Departments Fail', props<{ payload: any }>());

export const loadMoreDepartments = createAction('[Employee] Load More Departments', props<{ payload: {skip: number, limit: number} }>());
export const loadMoreDepartmentsSuccess = createAction('[Employee] Load More Departments Success', props<{ payload: any }>());
export const loadMoreDepartmentsFail = createAction('[Employee] Load More Departments Fail', props<{ payload: any }>());

export const loadAllDepartments = createAction('[Employee] Load All Departments');
export const loadAllDepartmentsSuccess = createAction('[Employee]  Load All Departments Success', props<{ payload: any }>());
export const loadAllDepartmentsFail = createAction('[Employee] Load All Departments Fail', props<{ payload: any }>());

export const searchDepartments = createAction('[Employee] Search Departments Departments', props<{ payload: any }>());
export const searchDepartmentsSuccess = createAction('[Employee] Search Departments Departments Success', props<{ payload: any }>());
export const searchDepartmentsFail = createAction('[Employee] Search Departments Departments Fail', props<{ payload: any }>());
